module.exports = __webpack_public_path__ + "static/media/Photos_top_medio_ambiente_apoyo.84971f93.png";